/**
 * @file   error-payload.js
 *         Implementation of ErrorPayload class. ErrorPayloads are specific payloads in Response
 *         messages when success is not true.
 * @author Wes Garland, wes@distributive.network
 * @date   Nov 2023
 */
'use strict';

const wallet = require('dcp/dcp-client/wallet');

exports.ErrorPayload = function ErrorPayload()
{
  /* base class - use to check if something is an ErrorPayload without regard to the connection */
}

exports.errorPayloadCtorFactory = function errorPayloadCtorFactory(connection)
{
  /** API */
  function ErrorPayload(error, code, Ctor = Error)
  {
    if (typeof error === 'string')
    {
      error = new Ctor(error);
      error.code = code;
    }

    const pds = Object.getOwnPropertyDescriptors(error);
    for (let propName in pds)
      pds[propName].enumerable = true
    Object.defineProperties(this, pds);
    this.origin = connection.identity.address;
    if (typeof code !== 'undefined')
      this.code = code;
  }
  ErrorPayload.prototype = new exports.ErrorPayload();

  /** Create an instance of ErrorPayload from an error-like object - eg. object from the network */
  ErrorPayload.from = function errorPayloadFrom(errorLikeObject)
  {
    const errorPayload = Object.create(ErrorPayload.prototype);

    Object.assign(errorPayload, errorLikeObject);
    if (errorPayload.origin)
      errorPayload.origin = new wallet.Address(errorPayload.origin);

    return errorPayload;
  }

  return ErrorPayload;
}
